import { render, staticRenderFns } from "./AuditItem.vue?vue&type=template&id=0db3010a&scoped=true&"
import script from "./AuditItem.vue?vue&type=script&lang=js&"
export * from "./AuditItem.vue?vue&type=script&lang=js&"
import style0 from "./AuditItem.vue?vue&type=style&index=0&id=0db3010a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3010a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VRadio,VRadioGroup})
